import { AdResPage } from './AdResPage';

export const adResRouter = {
  '/@/advance_reservation': AdResPage,
};
